import { ReactNode } from 'react'

import useLayout from 'common/hooks/useLayout'
import IconButton from 'common/components/iconButton'

import '@hotmart/cosmos/dist/modal/modal-header'
import '@hotmart/cosmos/dist/styles/utilities/spacing/spacing.css'
import '@hotmart/cosmos/dist/styles/utilities/sizing/sizing.css'
import '@hotmart/cosmos/dist/styles/utilities/display/display.css'
import '@hotmart/cosmos/dist/styles/utilities/flex/flex.css'

export interface Props {
  children: ReactNode,
  closeModal: () => void
}

const ModalHeader = ({ children, closeModal }: Props) => {
  const { isMobile } = useLayout()

  if (isMobile) {
    return (
      <div className="modal-mobile-header _d-flex _align-items-center">
        <IconButton
          className="_p-1 _mr-4 _w-5 _h-5 _flex-shrink-0"
          onClick={closeModal}
          iconName="arrow-left"
          prefix="far" />
        <div className="content _flex-grow-1">{children}</div>
      </div>
    )
  }

  return (
    <hot-modal-header>{children}</hot-modal-header>
  )
}

export default ModalHeader
